import React from 'react';
import classNames from 'classnames';
import Phone from '@material-ui/icons/PhoneInTalkOutlined';
import Support from 'assets/img/icons/support_agent.svg';
import { translate } from 'components/Translation';
import Card from 'components/Card/Card';
import CardBody from 'components/Card/CardBody';
import style from 'assets/jss/material-dashboard-pro-react/views/contactUs/contactCustomerCare';
import { HeadingLBold, BodyS, BodySBold } from 'components/Typography/Typography';
import { makeStyles } from '@material-ui/core';

// @ts-ignore
const useStyles = makeStyles(style);

const ContactCustomerCare = () => {
	const classes = useStyles();

	return (
		<div className={classes.contactCustomerCare}>
			<div className={classes.contactCustomerCareIconContainer}>
				<Card className={classes.card}>
					<div className={classes.iconContainer}>
						<Phone className={classNames(classes.icon, classes.contactIcon)} />
					</div>
				</Card>
			</div>
			<div className={classes.contactCustomerCareContainer}>
				<Card className={classes.card}>
					<CardBody className={classes.cardBody}>
						<div className={classes.contactCustomerCareFirstSection}>
							<HeadingLBold disableMargin>{translate('contact.info.header')}</HeadingLBold>
						</div>
						<div className={classes.simplyDial}>
							<BodyS disableMargin inline>
								{translate('contact.info.simplyDial1')}
							</BodyS>
							<BodySBold disableMargin inline>
								1235
							</BodySBold>
							<BodyS disableMargin inline>
								{translate('contact.info.simplyDial2')}
							</BodyS>
						</div>
						<div className={classes.callCentreWrapper}>
							<div className={classes.callCentre}>
								<div>
									<img
										alt="agent"
										src={Support}
										className={classNames(classes.supportIcon, classes.contactIcon)}
									/>
								</div>
								<div className={classes.customerServiceWrapper}>
									<BodyS disableMargin>{translate('contact.info.ourCallCentre')}</BodyS>
								</div>
							</div>
							<div className={classes.calls}>
								<BodySBold>{translate('contact.info.calls')}</BodySBold>
							</div>
						</div>
					</CardBody>
				</Card>
			</div>
		</div>
	);
};

export default ContactCustomerCare;
